import React from "react";
import UserContainer from "../containers/User";

const User = () => {
  return <UserContainer />;
};

export default User;
